import React, { Component } from "react";
import "react-table/react-table.css";
import "../../tables/reactTable.css";
import ReactTableComponent from "../../tables/ReactTable";
import MoreVertIcon from "@material-ui/icons/MoreVert";

import editicon from "../../../../src/Components/assets/edit.png";
import { getContactImageUrl } from "../../../config";
import { getContactImageUrl2 } from "../../../config";
import {
  campaignEngagedTabList,
  campaignEngagedTabSelectList,
  campaignEngegedExport,
  //campaignContactStatusMutation
} from "../../../Queries";

import { Checkbox } from "pretty-checkbox-react";
import SearchIcon from "../../assets/search.png";
import { TextField, Button, IconButton } from "@material-ui/core";
import swal from "sweetalert";
import Calender from "../../assets/calendar.png";
import "../CampaignTables.css";
import "../CampaignTabs.css";
//import ReactDOM from "react-dom";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";

//import Photo from "../../assets/photo.png";
import "../CampaignTabs.css";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";
import "./CampaignEngagedTab.css";
import { fetchMethod } from "../../../FetchMethod";
import ExportTo from "./EngagedToExcel";
import { Drawer } from "@material-ui/core";
import EngagedTo from "./EngagedTo";

import EngagedDetails from "./EngagedDetails";
import { connect } from "react-redux";
import {
  Engaged,
  dateFilter,
  engagedData,
  Profileid,
  plannedDate,
  UpdatefollowUp
} from "../campaignQueries";

const moment = require("moment");
class CampaignEngagedTab extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      search: "",
      loading: false,
      limit: 0,
      offset: 0,
      searchFlag: false,
      clickToSearch: false,
      campaignEngagedList: [],
      dataGrid: [],
      Engage: undefined,
      contactStatus: null,
      campaignStatus: null,
      columnFilter: "",
      shortfilter: false,
      contactId: null,
      Currentstage: [],
      selectDateResponse: undefined,
      DateResponse: undefined,
      EndDateResponse: undefined,
      invitationSent: [],
      totalCount: 0,
      startDate: null,
      endDate: null,
      show: "",
      openDetails: false,
      Row: "",
      ContactDetailsWorkflow: [],
      ContactDetailsMessages: [],
      selected: {},
      selectAll: 0,
      selectedArray: [],
      campaignEngagedAllSelectedList: [],
      profileid: undefined,
      salesforcetoken: null,
      hubspottoken: null,
      isSearching: false,
      campaignEngegedExportData: [],
      clientY: null,
      clientX: null
    };
  }
  componentDidMount() {
    this.ExportData();
    this.setState({ show: false }, () =>
      this.props.detailEdit(this.state.show)
    );
    this.EngagedData();
    this.Profile();
  }

  ExportData = () => {
    const filter = this.filter();
    fetchMethod(campaignEngegedExport, filter)
      .then(res => res.json())
      .then(res => {

        this.setState({
          campaignEngegedExportData: res.data.allContacts.Contacts
        });
      });
  };

  Profile = () => {
    fetchMethod(Profileid(this.props.campaignId))
      .then(res => res.json())
      .then(res => {
        this.setState({
          profileid:
            res.data.Campaigns.customercredentialsIbfk1rel
              .Customerlinkedinprofiles[0].id,
          hubspottoken:
            res.data.Campaigns.customercredentialsIbfk1rel
              .Customerlinkedinprofiles[0].hubspottoken,
          salesforcetoken:
            res.data.Campaigns.customercredentialsIbfk1rel
              .Customerlinkedinprofiles[0].salesforcetoken
        });
      })
      .catch(e => console.log(e));
  };

  emptySelectedArray = () => {
    this.setState({ selectedArray: [], selectAll: false, selected: {} });
  };
  EngagedData = () => {
    let filter = {
      where: {
        campaignid: this.props.campaignId,
        engaged: 1,
        noop: 0,
        campaignstatus: "PAUSE"
      }
    };
    fetchMethod(engagedData, filter)
      .then(res => res.json())
      .then(res => {
        res.data.allContacts !== undefined
          ? this.setState({ dataGrid: res.data.allContacts.Contacts })
          : this.setState({ loading: true });
      })
      .catch(e => swal({ title: e, icon: "warning" }));
  };

  handleStartDate1 = row => e => {
    this.setState({
      selectedEngagedRow: {
        ...row,

        anchorEl: e.currentTarget
      },
      clientY: e.clientY,
      clientX: e.clientX
    });
  };

  handleStartDate = date => {
    this.setState({ endDate: null });
    this.props.selected_Response(this.state.Engage);
    this.setState(
      {
        startDate: this.formatDate4(date)
      },
      () => {
        this.onSearchClick();
      }
    );
  };
  handleEndDate = date => {
    this.props.selected_Response(this.state.Engage);
    this.setState(
      {
        endDate: this.formatDate4(date)
      },
      () => {
        this.campaignDateListData();
      }
    );
  };

  SetLimit = limit => {
    this.setState({
      limit
    });
  };

  SetOffset = offset => {
    this.setState({ offset });
  };

  setEngagedListData = response => {
    this.setState(
      {
        campaignEngagedList: response.data.allContacts.Contacts,
        totalCount: response.data.allContacts.totalCount
      }

    );
  };

  afterCampaignEnddateData = () => {
    const filter = {
      where: {
        type: "RECEIVED",
        order: "createdon",
        messagedatetime: {
          gt: this.state.endDate + " 23:59:59"
        },
        and: [
          {
            or:
              this.state.campaignEngagedList.length > 0
                ? this.state.campaignEngagedList.map(id => {
                  return { contactid: id.id };
                })
                : [{ contactid: "" }]
          }
        ]
      }
    };

    fetchMethod(dateFilter, filter)
      .then(res => res.json())
      .then(res => {
        this.setState(
          {
            EndDateResponse:
              res.data.allContactmessages !== undefined &&
                res.data.allContactmessages !== null
                ? res.data.allContactmessages.Contactmessages
                : undefined
          },
          () => {
            this.campaignGridData();
            // this.onSearchClick();
          }
        );
      })
      .catch(e => {
        console.log(e);
        swal({ title: e, icon: "warning" });
      });
  };
  campaignGridData = () => {
    let data = [];

    if (
      this.state.EndDateResponse &&
      this.state.DateResponse &&
      this.state.EndDateResponse.length > 0 &&
      this.state.DateResponse.length > 0
    ) {
      this.state.DateResponse.map(date => {
        return this.state.EndDateResponse.map(id => {
          if (date.contactid !== id.contactid) {
            return data.push(date.contactid);
          } else {
            return {};
          }
        });
      });
    } else {
      this.state.DateResponse && this.state.DateResponse.length > 0
        ? this.state.DateResponse.map(id => {
          return data.push(id.contactid);
        })
        : data.push("");
    }
    const filter = {
      where: {
        type: "RECEIVED",
        order: "createdon",
        and: [
          {
            or:
              data !== ""
                ? data.map(id => {
                  return { contactid: id };
                })
                : [{ contactid: "" }]
          }
        ]
      }
    };

    fetchMethod(dateFilter, filter)
      .then(res => res.json())
      .then(res => {
        this.setState(
          {
            selectDateResponse:
              res.data.allContactmessages !== undefined &&
                res.data.allContactmessages !== null
                ? res.data.allContactmessages.Contactmessages
                : undefined
          },
          () => {
            this.props.selected_Response(this.state.selectDateResponse);
            this.onSearchClick();
          }
        );
      })
      .catch(e => swal({ title: e, icon: "warning" }));
  };

  campaignDateListData = () => {
    const filter = {
      where: {
        type: "RECEIVED",
        order: "createdon",

        and: [
          {
            or:
              this.state.dataGrid.length > 0
                ? this.state.dataGrid.map(id => {
                  return { contactid: id.id };
                })
                : [{ contactid: "" }]
          },
          {
            or:
              this.state.startDate !== null && this.state.endDate !== null
                ? [
                  {
                    messagedatetime: {
                      between: [
                        this.state.startDate + " 00:00:00",
                        this.state.endDate + " 23:59:59"
                      ]
                    }
                  }
                ]
                : [{}]
          }
        ]
      }
    };

    fetchMethod(dateFilter, filter)
      .then(res => res.json())
      .then(res => {
        this.setState(
          {
            DateResponse:
              res.data.allContactmessages !== undefined &&
                res.data.allContactmessages !== null
                ? res.data.allContactmessages.Contactmessages
                : undefined
          },
          () => {
            this.afterCampaignEnddateData();
          }
        );
      })
      .catch(e => swal({ title: e, icon: "warning" }));
  };

  onSearchClick = () => {
    if (this.state.searchFlag === true) {
      this.setState({ clickToSearch: true }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
      });
    } else {
      this.setState({ clickToSearch: false }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
      });
    }
  };

  debounce = (debounceTimer, func, delay) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(func, delay);
    return debounceTimer;
  };
  debounceTimer = null;
  handleSearchChange = event => {
    this.setState({
      search: event.target.value,
      searchFlag: true,
      isSearching: true
    });
    this.debounceTimer = this.debounce(
      this.debounceTimer,
      () => {
        this.onSearchClick();
        this.setState({ isSearching: false });
      },
      200
    );
  };

  formatDate3 = date => {

    if (date !== null && date !== undefined && date) {
      date = new Date(date);
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };
  formatDate4 = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(date);
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date = `${mm}/${dd}/${yyyy}`;
      return date;
    }

    return;
  };
  formatDate1 = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };

  formatDate = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };
  formatDate2 = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date = `${mm}/${dd}/${yyyy}`;
      return date;
    }
    return;
  };

  onSearchKeyDown = event => {
    return event.key === "Enter" ? this.onSearchClick() : "";
  };
  gettingAllDataFromQuery = () => {
    const filter = this.filter();
    fetchMethod(campaignEngagedTabSelectList, filter)
      .then(response => {
        return response.json();
      })
      .then(responseAsJson => {
        let allselectedIds = [];
        responseAsJson.data.allContacts.Contacts.map(i => {
          allselectedIds.push({ id: i.id });
        });
        this.setState(
          {
            campaignEngagedAllSelectedList: allselectedIds
          },
          () => {
            let selectedArr = [];
            let consolidateArray = [];
            this.state.campaignEngagedAllSelectedList.map(item => {
              consolidateArray[item.id] = true;
              selectedArr.push({ id: item.id });
            });
            this.setState({
              selectAll: true,
              selected: consolidateArray,
              selectedArray: selectedArr
            });
          }
        );
      })
      .catch(e => {
        console.log(e);
        this.setState({ loading: true });
      });
  };

  onRowSelected = sarray => {
    if (sarray.length === this.state.totalCount) {
      this.setState({ selectAll: true });
    } else {
      this.setState({ selectAll: false });
    }
  };

  toggleRowNew = (id, rowInfo) => {
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[id] = !this.state.selected[id];
    this.setState({
      selected: newSelected
    });
    const { selectedArray } = this.state;
    let arr = selectedArray.filter(val => val.id !== id);
    if (!arr.length) {
      this.setState(
        {
          selectedArray: []
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    }
    if (arr.length === selectedArray.length) {
      this.setState(
        {
          selectedArray: [...selectedArray, rowInfo]
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    } else {
      this.setState(
        {
          selectedArray: arr
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    }
  };

  toggleSelectAllRow = isChecked => {
    if (isChecked) {
      this.gettingAllDataFromQuery();
    } else {
      this.setState({
        selectAll: false,
        selectedArray: [],
        selected: {}
      });
    }
  };

  clearFilters = () => {
    this.setState(
      {
        search: "",
        searchFlag: false,
        startDate: null,
        endDate: null,
        selectDateResponse: undefined,
        clickToSearch: false,
        limit: 50,
        offset: 50
      },
      () => {
        this.props.selected_Response(this.state.selectDateResponse);
        this.onSearchClick();
        // this.ExportData();
      }
    );
  };
  fetchRefresh = response => {
    this.fetchMessage(response);
  };

  fetchMessage = response => {
    fetchMethod(Engaged(response))
      .then(res => res.json())
      .then(res => {
        res.data.allContacts !== undefined
          ? this.setState({
            ContactDetailsMessages:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].Contactmessagesfk
                  .Contactmessages
                : ""
          })
          : this.setState({ loading: true });
      })
      .catch(e => swal({ title: e, icon: "warning" }));
  };

  onTableRowClick = rowInfo => {
    this.setState({ Row: rowInfo.original.id });
  };

  fetchContactDrawerDetails = (side, open, row) => event => {

    fetchMethod(Engaged(row.id))
      .then(res => res.json())
      .then(res => {
        res.data.allContacts !== undefined
          ? this.setState({
            ContactDetailsWorkflow:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].Contactworkflowhistoryfk
                  .Contactworkflowhistories
                : "",

            ContactDetailsMessages:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].Contactmessagesfk
                  .Contactmessages
                : "",
            getData:
              res.data.allContacts !== undefined &&
                res.data.allContacts !== null
                ? res.data.allContacts.Contacts[0]
                : "",
            getCampaignId:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].campaignid
                : "",
            getCustomer:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null &&
                res.data.allContacts.Contacts[0].Campaigns.Campaigns.length > 0
                ? res.data.allContacts.Contacts[0].Campaigns.Campaigns[0]
                  .Customers.Customers[0]
                : "",
            contactStatus:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].contactstatus
                : "",
            campaignStatus:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].campaignstatus
                : "",
            contactId:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].id
                : ""
          })
          : this.setState({ loading: true });
      })
      .catch(e => swal({ title: e, icon: "warning" }));
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ ...this.state, [side]: open });
  };
  closeDetails = () => {
    this.setState({ openDetails: false });
  };

  NameFilter = () => {
    this.setState({ columnFilter: "name asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  NameFilter1 = () => {
    this.setState({ columnFilter: "name desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  CompanyFilter = () => {
    this.setState({ columnFilter: "organization asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  CompanyFilter1 = () => {
    this.setState(
      { columnFilter: "organization desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  PositionFilter = () => {
    this.setState({ columnFilter: "designation asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  PositionFilter1 = () => {
    this.setState(
      { columnFilter: "designation desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  LocationFilter = () => {
    this.setState({ columnFilter: "location asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  LocationFilter1 = () => {
    this.setState({ columnFilter: "location desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  connectedonFilter = () => {
    this.setState({ columnFilter: "connectedon asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  connectedonFilter1 = () => {
    this.setState(
      { columnFilter: "connectedon desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  InvitationsentFilter = () => {
    this.setState(
      { columnFilter: "invitationsent asc", shortfilter: true },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  InvitationsentFilter1 = () => {
    this.setState(
      { columnFilter: "invitationsent desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  currentstatusFilter = () => {
    this.setState(
      { columnFilter: "currentstatus asc", shortfilter: true },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  currentstatusFilter1 = () => {
    this.setState(
      { columnFilter: "currentstatus desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  lastResponseFilter = () => {
    this.setState(
      { columnFilter: "lastresponse asc", shortfilter: true },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  lastResponseFilter1 = () => {
    this.setState(
      { columnFilter: "lastresponse desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  filter = () => {
    const search = this.state.clickToSearch
      ? this.state.search.trim().replace(/\s\s+/g, " ")
      : "";

    const like = `%${search}%`;
    const filter = {
      where: {
        campaignid: this.props.campaignId,
        active: 1,
        engaged: 1,
        leads: 0, //when again recieved msg in leads
        noop: 0,
        campaignstatus: "PAUSE",
        order: this.state.columnFilter,

        and: [
          {
            or: [
              { name: { like: like, options: "i" } },
              { location: { like: like, options: "i" } },
              { designation: { like: like, options: "i" } },
              { organization: { like: like, options: "i" } }
            ]
          },
          {
            or:
              this.props.selectDateResponse !== undefined
                ? this.props.selectDateResponse.length > 0
                  ? this.props.selectDateResponse.map(id => {
                    return {
                      id: id.contactid
                    };
                  })
                  : [{ id: "" }]
                : [{}]
          }
        ]
      }
    };
    return filter;
  };
  handleStatusChange2 = (row, updateStatus, date) => event => {
    updateStatus = {
      where: { id: row.original.id },
      data: {
        followup: this.formatDate3(event)
      }
    };

    swal({
      title: "Are you sure want to convert?",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willConvert => {
      if (willConvert) {
        fetchMethod(UpdatefollowUp, updateStatus)
          .then(response => {
            return response.json();
          })
          .then(res => {
            if (res.data.ContactsUpsertWithWhere) {
              swal("Successfully updated", { icon: "success" }).then(() => {
                this.child.current.searchFetch(
                  this.state.limit,
                  this.state.offset
                );
              });
            } else swal("Error", { icon: "error" });
          })

          .catch(err => {
            console.log(err);
            swal("Error", { icon: "error" });
          });
      }
    });
  };

  showEngagedToPopup = row => e => {
    this.setState({
      selectedEngagedRow: {
        ...row,

        anchorEl: e.currentTarget
      },
      clientY: e.clientY,
      clientX: e.clientX
    });
  };

  showEngagedToPopup2 = row => e => {
    this.setState({
      selectedEngagedRow: {
        ...row,

        anchorEl: e.currentTarget
      },
      clientY: e.clientY,
      clientX: e.clientX
    });
  };

  onCloseEngagedPopup = () => {
    this.setState({ selectedEngagedRow: null });
  };

  render() {
    const { selectedEngagedRow } = this.state;
    const campaignEngagedList = [...this.state.campaignEngagedList];
    const campaignEngegedExportData = [...this.state.campaignEngegedExportData];
    const CampaignEngagedListHeaders = [
      {
        Header: obj => {
          return (
            <Checkbox
              defaultChecked
              size="small"
              value="small"
              color="primary"
              style="thick"
              inputProps={{ "aria-label": "checkbox with small size" }}
              checked={this.state.selectAll}
              onChange={e => {
                this.toggleSelectAllRow(e.target.checked);
              }}
            />
          );
        },
        Cell: rowInfo => {
          return (
            <Checkbox
              defaultChecked
              size="small"
              value="small"
              color="primary"
              style="thick"
              inputProps={{ "aria-label": "checkbox with small size" }}
              checked={this.state.selected[rowInfo.original.id] === true}
              onChange={() =>
                this.toggleRowNew(rowInfo.original.id, rowInfo.original)
              }
            />
          );
        }
      },
      {
        Header: "Image",
        accessor: "Image"
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.NameFilter
                  : this.NameFilter1
              }
            >
              Name
            </div>
          );
        },
        accessor: "Name",
        width: 150,
        Cell: row => (
          <div
            style={{ cursor: "pointer", color: "#2BADDD" }}
            onClick={this.fetchContactDrawerDetails(
              "openDetails",
              true,
              row.original
            )}
          >
            {row.original.name}
          </div>
        )
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.CompanyFilter
                  : this.CompanyFilter1
              }
            >
              Current Company
            </div>
          );
        },
        accessor: "organization",
        width: 150,
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.PositionFilter
                  : this.PositionFilter1
              }
            >
              Current Position
            </div>
          );
        },
        accessor: "designation",
        width: 150,
      },

      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.LocationFilter
                  : this.LocationFilter1
              }
            >
              Location
            </div>
          );
        },
        accessor: "location",
        width: 150,
      },

      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.connectedonFilter
                  : this.connectedonFilter1
              }
            >
              Connected On
            </div>
          );
        },
        accessor: "Connectedon",
        width: 110,
      },
      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.InvitationsentFilter
                  : this.InvitationsentFilter1
              }
            >
              Invitation Sent
            </div>
          );
        },
        accessor: "InvitationSent",
        width: 110,
      },

      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.currentstatusFilter
                  : this.currentstatusFilter1
              }
            >
              Current Stage
            </div>
          );
        },
        accessor: "CurrentStage",
        width: 110,
      },


      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.lastResponseFilter
                  : this.lastResponseFilter1
              }
            >
              Last Response
            </div>
          );
        },
        accessor: "LR",
        width: 110,
      },

      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
            >
              Follow Up
            </div>
          );
        },
        accessor: "followup",

        Cell: row => {
          return (
            <div
              className="iconButton"
              style={{
                color: row.original.followup2 == 1 ? "#FFBF00" : "red"
              }}
            >
              {row.original.followup}

              <span className="EditIcon">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    format="dd/MM/yyyy"
                    value={this.state.startDate}
                    // placeholder="dd/mm/yyyy"
                    onChange={this.handleStatusChange2(row)}
                    keyboardIcon={
                      <img src={editicon} alt="" style={{ width: "17px" }} />
                    }
                    InputProps={{
                      disableUnderline: true
                    }}
                    helperText={""}
                  />
                </MuiPickersUtilsProvider>
              </span>
            </div>
          );
        }
      },
      {
        Header: " Status",
        accessor: "CampaignStatus"
      },
      {
        Header: "",
        Cell: row => {
          return (
            <div className="iconButton" key={row.original.id}>
              {localStorage.getItem("role") !== "CUSTOMER" ? (
                <IconButton
                  aria-haspopup="true"
                  onClick={this.showEngagedToPopup(row)}
                >
                  <MoreVertIcon />
                </IconButton>
              ) : (
                ""
              )}
            </div>
          );
        }
      }
    ];

    campaignEngagedList.map(list => {
      if (
        list.lastresponse !== undefined &&
        list.lastresponse !== null &&
        list.lastresponse
      ) {
        list.LR = this.formatDate(list.lastresponse.split("T")[0]);
      }

      if (
        list.followup !== undefined &&
        list.followup !== null &&
        list.followup !== "" &&
        list.followup
      ) {

        var date = this.formatDate2(list.followup.split("T")[0]);
        var cmTime = new Date(date);
        var dateday = cmTime.getDay();
        if (dateday >= 3) {
          var lastDay = cmTime;
          lastDay.setDate(cmTime.getDate() + 5);
          var today = new Date();
          if (lastDay > today) {
            list.followup2 = 1;
          } else {
            list.followup2 = 0;
          }
        } else {
          var lastDay = cmTime;
          lastDay.setDate(cmTime.getDate() + 3);

          var today = new Date();
          if (lastDay > today) {
            list.followup2 = 1;
          } else {
            list.followup2 = 0;
          }
        }
      }
      if (
        list.followup !== undefined &&
        list.followup !== null &&
        list.followup !== "" &&
        list.followup
      ) {

        list.followup = this.formatDate(list.followup.split("T")[0]);
      }

      let image =
        list.profileimage !== undefined && list.profileimage !== null
          ? list.profileimage.substr(0, 5)
          : "";
      let imageSourceUrl = getContactImageUrl;
      if (image === "https") {
        if (list.id > 917500) {
          imageSourceUrl = getContactImageUrl2;
        }
        list.Image = (
          <div
            style={{ cursor: "pointer" }}
            onClick={this.fetchContactDrawerDetails("openDetails", true, list)}
          >
            <img
              src={list.profileimage}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = imageSourceUrl.url + list.image;
              }}
              style={{ borderRadius: "50%", width: "30px" }}
            />
          </div>
        );
      } else {
        list.Image = (
          <div
            style={{ cursor: "pointer" }}
            onClick={this.fetchContactDrawerDetails("openDetails", true, list)}
          >
            <img
              src={imageSourceUrl.url + list.image}
              style={{ borderRadius: "50%", width: "30px" }}
            />
          </div>
        );
      }


      list.Name = (
        <div
          style={{ cursor: "pointer" }}
          onClick={this.fetchContactDrawerDetails("openDetails", true, list)}
        >
          {list.name}
        </div>
      );

      list.CampaignStatus =
        list.campaignstatus !== null && list.campaignstatus !== undefined
          ? list.campaignstatus === "COMPLETED"
            ? "Completed"
            : list.campaignstatus === "PAUSE"
              ? "Pause"
              : "Live"
          : "";

      if (
        list.connectedon !== undefined &&
        list.connectedon !== null &&
        list.connectedon
      ) {
        list.Connectedon = this.formatDate1(list.connectedon);
      }

      if (
        list.connectedon !== undefined &&
        list.connectedon !== null &&
        list.connectedon
      ) {
        list.Connectedon = this.formatDate(list.connectedon);
      }
      if (
        list.invitationsent !== undefined &&
        list.invitationsent !== null &&
        list.invitationsent
      ) {
        list.InvitationSent = this.formatDate(
          list.invitationsent.split("T")[0]
        );
      }

      if (
        list.currentstatus !== undefined &&
        list.currentstatus !== null &&
        list.currentstatus
      ) {
        list.CurrentStage = list.currentstatus;
      }

      if (
        list.currentstatus !== undefined &&
        list.currentstatus !== null &&
        list.currentstatus
      ) {
        if (
          list.invitesent == 0 &&
          (list.currentstatus == "Invite Sent" ||
            list.currentstatus == "Invite Not Sent")
        ) {
          list.CurrentStage = "Invite not Sent";
        } else {
          list.CurrentStage = list.currentstatus;
        }

      }

      return null;
    });

    campaignEngegedExportData.map(list => {
      if (
        list.lastresponse !== undefined &&
        list.lastresponse !== null &&
        list.lastresponse
      ) {
        list.LR = list.lastresponse;
      }
      if (
        list.invitationsent !== undefined &&
        list.invitationsent !== null &&
        list.invitationsent
      ) {
        list.InvitationSent = list.invitationsent.split("T")[0];
      }
      if (
        list.currentstatus !== undefined &&
        list.currentstatus !== null &&
        list.currentstatus
      ) {
        list.CurrentStage = list.currentstatus;
      }
    });

    let filter = this.filter();

    return (
      <div className="CampaignEngagedTab">
        <div className="CampaignEngagedHeader">
          <div className="CampaignEngagedLeftFilters">

            <Drawer
              anchor="right"
              open={this.state.openDetails}
              onClose={() => this.closeDetails()}
            >
              <EngagedDetails
                onSearchClick={this.onSearchClick}
                refreshMessage={this.fetchRefresh}
                Close={() => this.closeDetails()}
                details={this.state.getData}
                Campaignid={this.state.getCampaignId}
                Customer={this.state.getCustomer}
                contactStatus={this.state.contactStatus}
                campaignStatus={this.state.campaignStatus}
                id={this.state.contactId}
                tableRerender={this.child.current}
                limit={this.state.limit}
                offset={this.state.offset}
                ContactDetailsWorkflow={this.state.ContactDetailsWorkflow}
                ContactDetailsMessages={this.state.ContactDetailsMessages}
                heading={"Contact Details"}
              />
            </Drawer>
            {/* )} */}
            <div className="datePicker">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="date-picker-dialog"
                  format="dd/MM/yyyy"
                  value={this.state.startDate}

                  onChange={this.handleStartDate}
                  KeyboardButtonProps={{
                    "aria-label": "change date"
                  }}
                  keyboardIcon={
                    <img src={Calender} alt="" style={{ width: "17px" }} />
                  }
                  InputProps={{
                    disableUnderline: true
                  }}
                  helperText={""}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className="datePicker1">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  id="date-picker1-dialog"
                  format="dd/MM/yyyy"
                  disabled={this.state.startDate !== null ? false : true}
                  value={this.state.endDate}
                  minDate={this.state.startDate}
                  // placeholder="dd/mm/yyyy"
                  onChange={this.handleEndDate}
                  KeyboardButtonProps={{
                    "aria-label": "change date"
                  }}
                  keyboardIcon={
                    <img src={Calender} alt="" style={{ width: "17px" }} />
                  }
                  InputProps={{
                    disableUnderline: true
                  }}
                  helperText={""}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div className="searchContact">
              <TextField
                id="outlined-search"
                label="Search"
                placeholder="Company/name/location/position"
                type="text"
                margin="normal"
                variant="outlined"
                value={this.state.search}
                onChange={this.handleSearchChange}
                onKeyDown={this.onSearchKeyDown}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <img
                      src={SearchIcon}
                      style={{ width: "15px", cursor: "pointer" }}
                      onClick={() => this.onSearchClick()}
                    />
                  )
                }}
              />
            </div>
          </div>

          {selectedEngagedRow && (
            <EngagedTo
              refresh={() => this.ExportData()}
              target={selectedEngagedRow && selectedEngagedRow.anchorEl}
              contactStatus={selectedEngagedRow.original.contactstatus}
              campaignStatus={selectedEngagedRow.original.campaignstatus}
              id={selectedEngagedRow.original.id}
              clientY={this.state.clientY}
              clientX={this.state.clientX}
              tableRerender={this.child.current}
              limit={this.state.limit}
              offset={this.state.offset}
              onClose={this.onCloseEngagedPopup}
              className={this.state.Row}
            />
          )}

          <div className="TotalRecordExport">
            <div style={{ minWidth: "130px" }}>
              <p style={{ color: "#36454d", fontSize: "15px" }}>
                Total Records: <span>{this.state.totalCount}</span>
              </p>
            </div>
            <div className="CampaignEngagedButton">
              <Button className="button" onClick={this.clearFilters}>
                <span style={{ textTransform: "capitalize" }}> Reset All</span>
              </Button>
            </div>
            <div className="RightContext">
              <ExportTo
                fileData={campaignEngegedExportData}
                SalesHubdata={this.state.selectedArray}
                Profile={this.state.profileid}
                selectedArray={this.emptySelectedArray}
                SalesforceToken={this.state.salesforcetoken}
                HubspotToken={this.state.hubspottoken}
              />
            </div>
          </div>
        </div>
        <ReactTableComponent
          ref={this.child}
          listData={campaignEngagedList}
          listConfig={CampaignEngagedListHeaders}
          setData={this.setEngagedListData}
          query={campaignEngagedTabList}
          totalCount={this.state.totalCount}
          setLimit={this.SetLimit}
          setOffset={this.SetOffset}
          filter={filter}
          clickToSearch={this.state.clickToSearch}
          onRowClick={this.onTableRowClick}
        />
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    startDate: state.startDate,
    endDate: state.endDate,
    selectDateResponse: state.selectDateResponse,
    campaignEngagedList: state.campaignEngagedList
  };
};

const mapDispatchToProps = dispatch => {
  return {
    selected_Response: data =>
      dispatch({ type: "Last_Response", payload: data })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CampaignEngagedTab);
